import { sessionService } from 'redux-react-session'
import { CALL_API } from 'redux-api-middleware'
import { push } from 'react-router-redux'
import { token } from '../utils'
import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
  LOGOUT_FAILURE,
  MERGE_REQUEST,
  MERGE_SUCCESS,
  MERGE_FAILURE,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILURE,
} from './types'
import {
  MERGE_NEWLOGIN,
} from '../constant'
const headers = {
  'x-session-token': token,
  'server-name': 'deknerd',
}
export const handleLogin = (endpoint, loginForm, redirect = null) => {
  return (dispatch) => {
    dispatch({
      [CALL_API]: {
        endpoint,
        method: 'POST',
        body: JSON.stringify(loginForm),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'x-session-token': token,
          'server-name': 'deknerd',
        },
        types: [
          LOGIN_REQUEST,
          {
            type: LOGIN_SUCCESS,
            payload: async (action, state, res) => {
              const response = await res.json()
              if (response.tokenWeb !== undefined) {
                const { displayName, imageURL, tokenWeb } = response
                await sessionService.saveSession({ token: tokenWeb })
                await sessionService.saveUser({ displayName, imageURL })
                // dispatch(push('/'))
                if (document.referrer.split('/')[3] === "course") {
                  window.location.replace(`/course/${document.referrer.split('/')[4]}`)
                } else if (document.referrer.split('/')[3] === "eTestingOverview") {
                  window.location.replace(`/eTestingOverview/${document.referrer.split('/')[4]}`)
                } else if (document.referrer.split('/')[3] === "packageDetail") {
                  window.location.replace(`/packageDetail/${document.referrer.split('/')[4]}`)
                }else if (document.referrer.split('/')[3] === "live") {
                  window.location.replace(`/live`)
                }else if(sessionStorage.getItem("fromUrl") !== null) {
                    let redirectUrl = sessionStorage.getItem("fromUrl")
                    sessionStorage.removeItem("fromUrl")
                    window.location.replace(redirectUrl)
                } else {
                  redirect !== null ? window.location.replace(redirect) : window.location.replace('/')
                }
              } else {
                // await sessionService.saveSession({ id: response._id })
                // await sessionService.saveSession({ email: response.email })
                // await sessionService.saveSession({ type: response.type })
                await sessionStorage.setItem('id', response._id)
                await sessionStorage.setItem('email', response.email)
                await sessionStorage.setItem('type', response.type)
                // await localStorage.setItem('password', loginForm.password)
                // await localStorage.setItem('token', loginForm)
                window.location.replace('/acceptMerge/')
              }
              return response
            },
          },
          {
            type: LOGIN_FAILURE,
            payload: async (action, state, res) => {
              return res.status
            },
          },
        ],
      },
    })
  }
}
export const resetPassword = (endpoint, loginForm) => {
  return (dispatch) => {
    dispatch({
      [CALL_API]: {
        endpoint,
        method: 'PUT',
        body: JSON.stringify(loginForm),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'x-session-token': token,
          'server-name': 'deknerd',
        },
        types: [
          RESET_PASSWORD_REQUEST,
          {
            type: RESET_PASSWORD_SUCCESS,
            payload: async (action, state, res) => {
              const response = await res.json()
              return response
            },
          },
          {
            type: RESET_PASSWORD_FAILURE,
            payload: async (action, state, res) => {
              return res.status
            },
          },
        ],
      },
    })
  }
}

export const handleLogout = (endpoint) => {
  return (dispatch) => {
    dispatch({
      [CALL_API]: {
        endpoint,
        method: 'GET',
        headers,
        types: [LOGOUT_REQUEST,
          {
            type: LOGOUT_SUCCESS,
            payload: async (action, state, res) => {
              const response = await res.json()
              await sessionService.deleteSession()
              await sessionService.deleteUser()
              if(sessionStorage.getItem("fromUrl") !== null) {
                let redirectUrl = sessionStorage.getItem("fromUrl")
                sessionStorage.removeItem("fromUrl")
                await window.location.replace(redirectUrl)
              } else{
                // await dispatch(push('/home'))
                await window.location.replace('/home')
                return response
              }
            },
          },
          LOGOUT_FAILURE,
        ],
      },
    })
  }
}
export const handleLoginForRegister = (endpoint, loginForm, redirect = null) => {
  return (dispatch) => {
    dispatch({
      [CALL_API]: {
        endpoint,
        method: 'POST',
        body: JSON.stringify(loginForm),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'x-session-token': token,
          'server-name': 'deknerd',
        },
        types: [
          LOGIN_REQUEST,
          {
            type: LOGIN_SUCCESS,
            payload: async (action, state, res) => {
              const response = await res.json()
              const { displayName, imageURL, tokenWeb } = response
              await sessionService.saveSession({ token: tokenWeb })
              await sessionService.saveUser({ displayName, imageURL })
              // dispatch(push('/'))
              return response
            },
          },
          {
            type: LOGIN_FAILURE,
            payload: async (action, state, res) => {
              return res.status
            },
          },
        ],
      },
    })
  }
}
export const handleMerge = (endpoint, loginForm, redirect) => {
  return (dispatch) => {
    dispatch({
      [CALL_API]: {
        endpoint,
        method: 'POST',
        body: JSON.stringify(loginForm),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'x-session-token': token,
          'server-name': 'deknerd',
        },
        types: [
          MERGE_REQUEST,
          {
            type: MERGE_SUCCESS,
            payload: async (action, state, res) => {
              const response = await res.json()
              const { displayName, imageURL, tokenWeb } = response
              await sessionService.saveSession({ token: tokenWeb })
              await sessionService.saveUser({ displayName, imageURL })
              // dispatch(push('/'))
              if (document.referrer.split('/')[3] === 'course') {
                window.location.replace(`/course/${document.referrer.split('/')[4]}`)
              } else {
                redirect !== null ? window.location.replace(redirect) : window.location.replace('/successMerge')
              }
              return response
            },
          },
          {
            type: MERGE_FAILURE,
            payload: async (action, state, res) => {
              return res.status
            },
          },
        ],
      },
    })
  }
}
export const handleLoginMerge = (endpoint, loginForm, mergeForm, redirect = null) => {
  return (dispatch) => {
    dispatch({
      [CALL_API]: {
        endpoint,
        method: 'POST',
        body: JSON.stringify(loginForm),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'x-session-token': token,
          'server-name': 'deknerd',
        },
        types: [
          LOGIN_REQUEST,
          {
            type: LOGIN_SUCCESS,
            payload: async (action, state, res) => {
              const response = await res.json()
              if (response.tokenWeb !== undefined) {
                // const { displayName, imageURL, tokenWeb } = response
                // await sessionService.saveSession({ token: tokenWeb })
                // await sessionService.saveUser({ displayName, imageURL })
                // dispatch(push('/'))
                await sessionStorage.clear()
                await dispatch(handleMerge(MERGE_NEWLOGIN, mergeForm, redirect))
                // if (document.referrer.split('/')[3] === 'course') {
                //   // window.location.replace(`/course/${document.referrer.split('/')[4]}`)
                // } else {
                //   // redirect !== null ? window.location.replace(redirect) : window.location.replace('/successMerge')
                // }
              } else {
                // await sessionService.saveSession({ id: response._id })
                // await sessionService.saveSession({ email: response.email })
                // await sessionService.saveSession({ type: response.type })
                await sessionStorage.setItem('id', response._id)
                await sessionStorage.setItem('email', response.email)
                await sessionStorage.setItem('type', response.type)
                // await localStorage.setItem('password', loginForm.password)
                window.location.replace('/acceptMerge/')
              }
              return response
            },
          },
          {
            type: LOGIN_FAILURE,
            payload: async (action, state, res) => {
              return res.status
            },
          },
        ],
      },
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/login.js